import { useEffect, useState } from 'react';

const NAV = [
  { label: '实时热榜', href: '#hot' },
  { label: '上升最快', href: '#rising' },
  { label: '瓜田分类', href: '#category' },
  { label: '深度吃瓜', href: '#deep' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-xl font-bold text-foreground-950">快瓜</span>
              <span className="block text-[10px] font-medium uppercase tracking-[0.18em] text-foreground-500">
                Gua Radar
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#hot"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800"
            >
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
              </span>
              爆瓜预警
            </a>
            <a
              href="#subscribe"
              className="whitespace-nowrap inline-flex items-center rounded-full bg-primary-500 px-4 md:px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              订阅瓜讯
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? '关闭菜单' : '打开菜单'}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 bg-background-50/70 text-foreground-900 lg:hidden"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 transition hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center rounded-lg bg-primary-500 px-3 py-3 text-sm font-semibold text-background-50"
            >
              订阅瓜讯
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}